module.exports = __webpack_public_path__ + "static/media/logo.e3ec2ac9.png";